import React, { useEffect } from "react";
import { requestLogoutUser } from "../../services/api/auth-api";
import PageLoading from "../Globo/PageLoading/PageLoading";
import { logout } from "../../shared/constants/login-store";

const Logout = () => {
  useEffect(() => {
    requestLogoutUser();
    logout();
    // eslint-disable-next-line
  }, []);

  return <PageLoading message="Redirecionando, aguarde." />;
};

export default Logout;
